import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDotProgressIndicatorStep } from '../../interfaces/dot-progress-indicator-step-interface';

@Component({
  selector: 'app-dot-progress-indicator',
  templateUrl: './dot-progress-indicator.component.html',
  styleUrls: ['./dot-progress-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DotProgressIndicatorComponent implements OnInit {
  @Input() steps: IDotProgressIndicatorStep[]

  @Output() stepActivated: EventEmitter<IDotProgressIndicatorStep> = new EventEmitter();

  private currentStep: IDotProgressIndicatorStep;
  private nextStep: IDotProgressIndicatorStep;


  ngOnInit(): void {
    this.currentStep = this.steps[0];
    this.nextStep = this.steps[1];
  }

  setStepActive(step: IDotProgressIndicatorStep): void {    
    if (step.canActivatePredicate === undefined || step.canActivatePredicate()) {
      this.steps.forEach(x => x.isActive = false);
      step.isActive = true;
      this.currentStep = step;
      const currentStepCopy = {...this.currentStep};
      this.nextStep = this.steps[++currentStepCopy.id];

      this.stepActivated.next(step);
    }
  }

  public selectStep(id: any): void {
    const step = this.steps.find(x => x.id === id);
    if (step) {
      this.setStepActive(step);
    }
  }

  public canActivateNext(): boolean {
    return this.nextStep?.canActivatePredicate && this.nextStep?.canActivatePredicate();
  }

  public next(): void {
    this.selectStep(this.nextStep?.id);
  }
}
